/**
 * @fileoverview gRPC-Web generated client stub for pb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v5.29.1
// source: proto/image_upload.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.pb = require('./image_upload_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.pb.ImageUploadServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.pb.ImageUploadServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.ImageUploadRequest,
 *   !proto.pb.ImageUploadResponse>}
 */
const methodDescriptor_ImageUploadService_UploadImage = new grpc.web.MethodDescriptor(
  '/pb.ImageUploadService/UploadImage',
  grpc.web.MethodType.UNARY,
  proto.pb.ImageUploadRequest,
  proto.pb.ImageUploadResponse,
  /**
   * @param {!proto.pb.ImageUploadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pb.ImageUploadResponse.deserializeBinary
);


/**
 * @param {!proto.pb.ImageUploadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.ImageUploadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.ImageUploadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.ImageUploadServiceClient.prototype.uploadImage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.ImageUploadService/UploadImage',
      request,
      metadata || {},
      methodDescriptor_ImageUploadService_UploadImage,
      callback);
};


/**
 * @param {!proto.pb.ImageUploadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.ImageUploadResponse>}
 *     Promise that resolves to the response
 */
proto.pb.ImageUploadServicePromiseClient.prototype.uploadImage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.ImageUploadService/UploadImage',
      request,
      metadata || {},
      methodDescriptor_ImageUploadService_UploadImage);
};


module.exports = proto.pb;

